"use client";

import Link from "next/link";
import { useEffect, useState, useCallback } from "react";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import { FaAngleDown, FaAngleRight } from "react-icons/fa";
// import Image from "next/image";  
 
// import Logo from "../img/logo.svg"; 

const DESKTOP_BREAKPOINT = 992;

const NavBar = () => {
  const [isDesktop, setIsDesktop] = useState(false);
  const [hovered, setHovered] = useState({
    services: false,
    mua: false,
    resources: false,
  });

  // ✅ Handle window resize to toggle desktop mode
  const updateViewport = useCallback(() => {
    setIsDesktop(window.innerWidth >= DESKTOP_BREAKPOINT);
  }, []);

  useEffect(() => {
    updateViewport();
    window.addEventListener("resize", updateViewport);
    return () => window.removeEventListener("resize", updateViewport);
  }, [updateViewport]);

  // ✅ Hover controls (only for desktop)
  const onEnter = (key) => {
    if (isDesktop) setHovered((s) => ({ ...s, [key]: true }));
  };
  const onLeave = (key) => {
    if (isDesktop) setHovered((s) => ({ ...s, [key]: false }));
  };

  return (
    <Navbar expand="lg" className="pt-4">
      <Container>
        {/* ---------- Logo ---------- */}
        <Navbar.Brand href="https://appran.com/" target="_blank" className="text-white fw-bold display-4 fs-2">
          {/* <Image src={Logo} width={60} height={60} alt="AppRan" priority /> */}
          <h6 className="m-0 text-white fw-bold display-6 text-decoration-none">appran.</h6>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          {/* ---------- Navigation Links ---------- */}
          <Nav className="mx-auto align-items-center">
            {/* -------- Services -------- */}
            <NavDropdown
              title={
                <span className="text-white d-inline-flex align-items-center">
                  Services <FaAngleDown className="ms-1" />
                </span>
              }
              className="dropdown text-white no-caret"
              show={isDesktop ? hovered.services : undefined}
              onMouseEnter={() => onEnter("services")}
              onMouseLeave={() => onLeave("services")}
            >
              <NavDropdown.Item className="dropdown-item text-white" href="https://appran.com/#packages-section">
                App Store Optimization
              </NavDropdown.Item>

              {/* -------- Nested: Mobile User Acquisition -------- */}
              <NavDropdown
                title={
                  <span className="text-white d-inline-flex align-items-center">
                    Mobile User Acquisition <FaAngleRight className="ms-1" />
                  </span>
                }
                className="dropend dropdownItem no-caret"
                drop="end"
                show={isDesktop ? hovered.mua : undefined}
                onMouseEnter={() => onEnter("mua")}
                onMouseLeave={() => onLeave("mua")}
              >
                <NavDropdown.Item className="dropdown-item text-white" href="https://appran.com/applesearchads">
                  Apple Search Ads
                </NavDropdown.Item>
                <NavDropdown.Item className="dropdown-item text-white" href="https://appran.com/facebookads">
                  Facebook Mobile Ads
                </NavDropdown.Item>
                <NavDropdown.Item className="dropdown-item text-white" href="https://appran.com/tiktokads">
                  TikTok Mobile Ads
                </NavDropdown.Item>
                <NavDropdown.Item className="dropdown-item text-white" href="https://appran.com/instagrammobileads">
                  Instagram Mobile Ads
                </NavDropdown.Item>
                <NavDropdown.Item className="dropdown-item text-white" href="https://appran.com/redditads">
                  Reddit Mobile Ads
                </NavDropdown.Item>
                <NavDropdown.Item className="dropdown-item text-white" href="https://appran.com/googleads">
                  Google Mobile Ads
                </NavDropdown.Item>
                <NavDropdown.Item className="dropdown-item text-white" href="https://appran.com/skanaudit">
                  SKAN 4.0 Audit
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown.Item className="dropdown-item text-white" href="https://appran.com/ugcvideoads">
                UGC Video Ads
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link href="https://appran.com/pricing" className="nav-link text-white">
              Pricing
            </Nav.Link>

            {/* -------- Resources -------- */}
            <NavDropdown
              title={
                <span className="text-white d-inline-flex align-items-center">
                  Resources <FaAngleDown className="ms-1" />
                </span>
              }
              className="dropdown text-white no-caret"
              show={isDesktop ? hovered.resources : undefined}
              onMouseEnter={() => onEnter("resources")}
              onMouseLeave={() => onLeave("resources")}
            >
              <NavDropdown.Item className="dropdown-item text-white" target="_blank" href="https://blog.appran.com/">
                Blog
              </NavDropdown.Item>
              <NavDropdown.Item className="dropdown-item text-white" target="_blank" href="https://case-studies.appran.com/">
                Case Studies
              </NavDropdown.Item>
              <NavDropdown.Item className="dropdown-item text-white" target="_blank" href="https://solutions.appran.com/">
                Solutions
              </NavDropdown.Item>
              <NavDropdown.Item className="dropdown-item text-white" href="https://appran.com/#testimonials-section">
                Testimonials
              </NavDropdown.Item>
              <NavDropdown.Item className="dropdown-item text-white" href="https://glossary.appran.com/">
                Glossary
              </NavDropdown.Item>
            </NavDropdown>

            <Nav.Link href="/#faq-section" className="nav-link text-white">
              FAQs
            </Nav.Link>
          </Nav>

          {/* ---------- Button ---------- */}
          <div className="me-0">
            <Link
              href="https://calendly.com/admin-appran/appran-intro-meeting"
              className={`btn btn-lg btn-gradient rounded-pill py-3 px-5 fw-bold mx-2 btnSolid`}
              target="_blank"
            >
              <span className="text-white fs-6 fw-semibold">Book a Meeting</span>
            </Link>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
